module.exports = __webpack_public_path__ + "img/wximg15.e021b1b7.png";